function Login({googlebuttonref}) {
  return (
    <div>
      <div className="Login">
        <div className="loginCard">
          <p className="loginTitle">Sistema de Reservaciones</p>
          <p className="loginSubtitle">Accede con tu cuenta corporativa</p>
          <div className="btnGoogle" ref={googlebuttonref}></div>
        </div>
      </div>
    </div>
  );
}

export default Login;
